import React from "react";
import HelpIcon from "./HelpIcon";
import PriceByTextForm from "./PriceByTextForm";
import { User } from "~/common/Store/models/User";
import LoginLink from "../LoginLink";
interface Props {
  itemNumber: string;
  showLoginLink?: boolean;
  showContactPhoneNumber?: boolean;
  user: User;
  chatHours: string;
}
const GetPriceByText = ({
  itemNumber,
  showLoginLink,
  showContactPhoneNumber,
  user,
  chatHours
}: Props) => {
  const getPriceByTextVerbiage = showLoginLink ? " or get price by text! " : "Get the price by text! ";
  return <>
      <p className="price enter-email">
        {showLoginLink && <LoginLink>Login</LoginLink>}
        {getPriceByTextVerbiage}
        <HelpIcon data-sentry-element="HelpIcon" data-sentry-source-file="index.tsx" />
      </p>
      <PriceByTextForm itemNumber={itemNumber} billingPhoneNumber={user.billingPhoneNumber} data-sentry-element="PriceByTextForm" data-sentry-source-file="index.tsx" />
      {showContactPhoneNumber && <p className="to-see-price noborder mb-2">
          Or call 717-392-7472
          <em>{chatHours}</em>
        </p>}
    </>;
};
export default GetPriceByText;